import { Email } from '@clearkit/icons';

import { PageLayout } from '~/components/PageLayout';
import { TeamNotificationSettings } from '~/components/profile/NotificationSettings';

export const PageTeamNotifications = () => (
  <PageLayout>
    <PageLayout.Header>
      <PageLayout.Tile>
        <Email />
      </PageLayout.Tile>
      <PageLayout.Heading>Email & Notifications</PageLayout.Heading>
      <PageLayout.SubHeading>
        Manage notifications for your team
      </PageLayout.SubHeading>
    </PageLayout.Header>
    <PageLayout.Body>
      <PageLayout.Content>
        <TeamNotificationSettings />
      </PageLayout.Content>
    </PageLayout.Body>
  </PageLayout>
);
